// extracted by mini-css-extract-plugin
module.exports = {"root":"sustainabilityDashboardPromo_root__faozz","img":"sustainabilityDashboardPromo_img__HMgpJ"};